import Vue from 'vue'

export const tabulationEditorDialogs = Vue.observable({ items: [] })

let dialogSequence = 0

export function openTabulationEditor(options = {}) {
  dialogSequence += 1
  const key = `tabulation-editor-${Date.now()}-${dialogSequence}`

  tabulationEditorDialogs.items.push({
    key,
    moduleId: options.moduleId,
    tabulationId: options.tabulationId ?? options.id ?? 'new',
    contextKey: key,
    title: options.title || (String(options.tabulationId ?? options.id ?? 'new') === 'new'
      ? 'Nouvelle tabulation'
      : 'Édition de la tabulation'),
    width: options.width || 1500,
    persistent: Boolean(options.persistent),
    onSaved: typeof options.onSaved === 'function' ? options.onSaved : null,
    onClosed: typeof options.onClosed === 'function' ? options.onClosed : null,
  })

  return key
}

export function closeTabulationEditor(key, result = null) {
  const index = tabulationEditorDialogs.items.findIndex(item => item.key === key)
  if (index === -1) return

  const [item] = tabulationEditorDialogs.items.splice(index, 1)
  if (item.onClosed) item.onClosed(result)
}

export function notifyTabulationSaved(key, tabulation) {
  const item = tabulationEditorDialogs.items.find(dialog => dialog.key === key)
  if (item && item.onSaved) item.onSaved(tabulation)
}

export function tabulationEditorLocation(options = {}) {
  return {
    name: 'engine-tabulation-edit',
    params: {
      moduleId: options.moduleId,
      tabulationId: options.tabulationId ?? options.id ?? 'new',
    },
  }
}
